import { Injectable } from "@angular/core";
import * as io from 'socket.io-client'
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SocketService {

    socket: SocketIOClient.Socket
    static ENV = environment;

    constructor() {
        if(!this.socket){
            this.socket = io(SocketService.ENV.environment.REPORTS.websocket, { secure: true })
        }
    }

    public emit(event: string, data: any){
        this.socket.emit(event, data)
    }

    public on(event: string): Observable<any> {
        return Observable.create(
            (observer) => {
                this.socket.on(event, data => {
                    observer.next(data)
                    observer.complete();
                })
            }
        )
    }



}


// WEBPACK FOOTER //
// ./src/app/core/services/websocket/socket.service.ts